<template>
	<div>
		<h2 class="title">
			<svg class="icon" aria-hidden="true">
				<use xlink:href="#icon-iconfillexpression"></use>
			</svg>
			表现记录
		</h2>
		<el-table :data="tableData" :class="{ 'table-wrap': true, 'total-bottom-radius': !showPagination }">
			<el-table-column prop="record_date" label="日期" width="260" />
			<el-table-column label="表现">
				<template slot-scope="scope">
					<div class="performance-state-colum">
						<svg class="icon" aria-hidden="true" :style="`fill:${getPerformanceTypeIconColor(scope.row.type)}`">
							<use :xlink:href="`#icon-${getPerformanceTypeIconName(scope.row.type)}`"></use>
						</svg>
						<div class="comment">
							<div class="state">
								{{ scope.row.performance }}
							</div>
							<div class="describe" v-if="scope.row.performance_describe">
								{{ scope.row.performance_describe }}
							</div>
						</div>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination-wrap" v-if="showPagination">
			<el-pagination
				background
				layout="prev, pager, next"
				:total="pagination.total"
				:page-size="pagination.size"
				:current-page.sync="pagination.page"
				@current-change="fetchPerformanceList"
			/>
		</div>
	</div>
</template>
<script>
const POSITIVE_PERFORMANCE = 1
const NEGATIVE_PERFORMANCE = 2
const OTHER_PERFORMANCE = 3
export default {
	name: 'StudentPerformanceList',
	props: {
		subjectId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			tableData: [],
			pagination: {
				page: 1,
				size: 5,
				total: 0
			}
		}
	},
	created() {
		this.fetchPerformanceList()
	},
	methods: {
		async fetchPerformanceList() {
			const res = await this.$api.teacher.list_performance({
				subject_id: this.subjectId,
				page: this.pagination.page,
				page_size: this.pagination.size
			})
			this.tableData = res.data
			this.pagination = {
				...this.pagination,
				page: res.meta.current_page,
				total: res.meta.total
			}
		},
		getPerformanceTypeIconName(type) {
			const iconNameList = ['iconfillsmile', 'iconfillsad', 'iconfillnoemotion']
			return iconNameList[type - 1]
		},
		getPerformanceTypeIconColor(type) {
			if (type === POSITIVE_PERFORMANCE) return '#26BF3D'
			if (type === NEGATIVE_PERFORMANCE) return '#EF4242'
			if (type === OTHER_PERFORMANCE) return '#CCC'
		}
	},
	computed: {
		showPagination() {
			return this.pagination.total > this.pagination.size
		}
	},
	watch: {
		subjectId: {
			immediate: true,
			handler() {
				this.fetchPerformanceList()
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.title {
	height: 24px;
	opacity: 1;
	font-size: 18px;
	font-family: MicrosoftYaHeiSemibold;
	text-align: left;
	color: #21a74a;
	line-height: 24px;
	margin-left: 20px;
	display: flex;
	align-items: center;
	.icon {
		font-size: 24px;
	}
}
.table-wrap {
	box-sizing: border-box;
	margin: 12px 20px 0px 20px;
	width: 1010px;
	border: 1px solid #ebeef5;
	border-radius: 5px;
	border-bottom-left-radius: 0px;
	border-bottom-right-radius: 0px;

	/deep/ thead th {
		border-top: 0px;
		padding-left: 10px !important;
	}

	/deep/ tbody tr td {
		padding-left: 10px !important;
	}

	/deep/ tbody tr:last-child td {
		border-bottom: 0px;
	}

	.performance-state-colum {
		display: flex;
		align-items: center;
		.icon {
			font-size: 24px;
			margin-right: 7px;
		}

		.comment {
			display: flex;
			flex-direction: column;
			.state {
				height: 19px;
				font-size: 14px;
				font-family: Microsoft YaHei;
				color: #666666;
				line-height: 19px;
			}
			.describe {
				height: 16px;
				font-size: 12px;
				font-family: Microsoft YaHei;
				text-align: left;
				color: #999999;
				line-height: 16px;
			}
		}
	}
}

.total-bottom-radius {
	margin-bottom: 20px;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
}

.pagination-wrap {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 60px;
	border: 1px solid #ebeef5;
	border-top: 0px;
	width: 1010px;
	margin: 0px 20px;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
	margin-bottom: 20px;
	box-sizing: border-box;
}
</style>
